import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    carousel: '[--slide-size:100%]',

    banner: 'bg-accent relative w-full',
    picture: 'absolute inset-0',

    upperTextWrapper: 'w-full',
    upperText: 'w-full border-t-1 border-b-1 uppercase',
    upperTextContainer: 'flex gap-10 px-5 md:gap-40 md:px-20',
    upperTextItem: 'inline-block md:min-w-[200px]',

    content: ['relative flex flex-col', 'md:px-5'],
    contentCenter: 'flex flex-col gap-5.5 px-3 md:gap-7.5',
    title: ['decoration-1 underline-offset-4 md:underline-offset-8', 'flex flex-col'],
    titleFirstLine: 'heading-3xl md:heading-2xl-desk leading-none! uppercase',
    titleSecondLine: '',
    description: 'heading-m',

    button: 'relative z-10 min-w-[150px]',

    dots: [
      'absolute z-20 w-57',
      'max-lg:top-7.5 max-lg:right-0 max-lg:left-0',
      'lg:right-15 lg:bottom-15'
    ],
    dot: 'w-10 bg-white/80',
    activeDot: 'w-15 bg-white md:w-25'
  },
  variants: {
    mode: {
      light: {
        content: 'text-white'
      },
      dark: {
        content: 'text-black'
      }
    },
    underline: {
      true: {
        title: 'underline'
      }
    },
    textAlign: {
      left: {
        content: 'items-start',
        contentCenter: 'items-start text-left',
        title: 'items-start text-left',
        description: 'text-left'
      },
      center: {
        content: 'items-center',
        contentCenter: 'items-center text-center',
        title: 'items-center text-center',
        description: 'text-center'
      },
      right: {
        content: 'items-end',
        contentCenter: 'items-end text-right',
        title: 'items-end text-right',
        description: 'text-right'
      }
    },
    buttonAlign: {
      left: {
        button: 'self-start'
      },
      center: {
        button: 'self-center'
      },
      right: {
        button: 'self-end'
      }
    },
    location: {
      default: {
        upperText: 'heading-s py-1.5',
        upperTextWrapper: '-mt-5',
        upperTextContainer: 'flex gap-10 px-5 md:gap-40 md:px-20',

        content: ['gap-12 max-md:py-9.5 md:py-10'],

        titleSecondLine: 'heading-italic-l md:heading-italic-xl'
      },
      product: {
        carousel: '[--container-spacing:0]',

        upperText: 'heading-xs py-px',
        upperTextWrapper: '-mt-2.5',

        content: ['gap-7.5 pt-5 pb-7'],

        titleSecondLine: 'heading-italic-m lg:text-[32px]'
      },
      menu: {
        carousel: '[--container-spacing:0]',

        upperText: 'heading-s border-secondary border-t-0 py-2',
        upperTextWrapper: '',

        content: ['gap-10 pt-0 pb-10 md:px-0'],
        contentCenter: ['md:gap-6'],

        button: 'h-auto',

        titleSecondLine: 'heading-italic-m lg:heading-2xl-desk'
      }
    }
  },
  defaultVariants: {
    textAlign: 'center',
    buttonAlign: 'center'
  }
});
